module.exports = __webpack_public_path__ + "static/img/exposure-pc-1.d2eddcac.png";